import { motion } from "framer-motion";
import { Feather, Crosshair, Landmark } from "lucide-react";

const PILLARS = [
  { testid: "principio-simple-por-diseno", icon: Feather, title: "Simple por diseño", text: "Sin menús interminables ni semanas de formación." },
  { testid: "principio-centrado-en-maquina", icon: Crosshair, title: "Centrado en la máquina", text: "Toda la información se organiza alrededor del activo." },
  { testid: "principio-construido-para-durar", icon: Landmark, title: "Construido para durar", text: "Su historia permanece aunque cambien personas, proveedores o sistemas." },
];

export default function Principles() {
  return (
    <section data-testid="principios-container">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <div className="grid sm:grid-cols-3 gap-12 sm:gap-10 lg:gap-16">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.testid}
              data-testid={p.testid}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
            >
              <span className="h-12 w-12 rounded-2xl bg-zinc-100 flex items-center justify-center text-zinc-700 mb-6">
                <p.icon size={20} strokeWidth={1.8} />
              </span>
              <h3 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-zinc-900">
                {p.title}
              </h3>
              <p className="text-base text-zinc-600 leading-relaxed mt-3">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
